import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { propIn } from '../../../../../../../common/utils/immutableHelper';
import { listSeparator } from '../../../../../../../common/utils/stringUtil';
import { gridPointsToPixels } from '../../../../../../utils/grid/gridUtils';

import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import StandardNotificationBoardTitle from './StandardNotificationBoardTitle';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';
import EmojiImage from '../../../../../../components/emoji/EmojiImage';

import './NotificationEntryReaction.scss';

const EmojiCodesList = ({ emojiList, gridSize }) => (
    <Fragment>
        {emojiList.map((emojiCode, index, self) => {
            const separator = listSeparator(index, self.length);

            return (
                <Fragment key={emojiCode}>
                    <EmojiImage size={gridPointsToPixels(1.6, gridSize)} emojiCode={emojiCode} />
                    {separator}
                </Fragment>
            );
        })}
    </Fragment>
);

EmojiCodesList.propTypes = {
    emojiList: PropTypes.array,
    gridSize: PropTypes.number,
};

const NotificationEntryAssignment = (props) => {
    const { actors, notification, gridSize } = props;

    const emojiList = propIn(['details', 'emojiCodes'], notification)
        ? propIn(['details', 'emojiCodes'], notification).toJS()
        : [];

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryReaction"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-reaction" />} />}
        >
            <UserNames users={actors} />
            {' reacted with '}
            <EmojiCodesList emojiList={emojiList} gridSize={gridSize} />
            &nbsp;
            <StandardNotificationBoardTitle {...props} />
        </BaseNotificationEntry>
    );
};

NotificationEntryAssignment.propTypes = {
    notification: PropTypes.object,
    actors: PropTypes.array,
    gridSize: PropTypes.number,
};

export default NotificationEntryAssignment;
